import { WORKSPACE_REQUEST, WORKSPACE_SUCCESS, WORKSPACE_FAILURE } from 'actions';

const initialState = {
    dataByKey: {},
    isFetching: [],
};

/**
 * One entry per (competition, day, tatami).
 *
 * A refresh keeps the previous payload in place until the new one arrives, so
 * a poll never blanks the mat a secretary is reading mid-fight.
 */
const workspaceReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case WORKSPACE_REQUEST:
            return {
                ...state,
                isFetching: [...state.isFetching.filter(k => k !== action.key), action.key],
            };

        case WORKSPACE_SUCCESS:
            return {
                ...state,
                dataByKey: { ...state.dataByKey, [action.key]: action.data },
                isFetching: state.isFetching.filter(k => k !== action.key),
            };

        case WORKSPACE_FAILURE:
            return { ...state, isFetching: state.isFetching.filter(k => k !== action.key) };

        default:
            return state;
    }
};

export default workspaceReducer;
